import React, { useEffect, useState } from 'react';

const BrowserDetails = ({ isOpen, onClose, data }) => {
  const [browserData, setBrowserData] = useState({})

  useEffect(() => {
    try {
      const browserParsedData = JSON.parse(data.browserDetails);
      setBrowserData(browserParsedData)
    } catch (error) {
      console.error("Error parsing locationDetails:", error);
    }

  }, [data])

  return (
    <React.Fragment>
      <div
        className={`modal fade ${isOpen ? "show d-block" : ""}`}
        tabIndex={-1}
        role="dialog"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-top"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">
                Browser And Connection Details
              </h6>
              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body bg-secondary">
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-bordered align-items-center table-flush">

                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>{browserData.Name || "N/A"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-default"
                onClick={onClose}
              >
                <i class="fa fa-times" aria-hidden="true"></i> Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default BrowserDetails;